import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.8);

  .content {
    background-color: white;
    padding: 32px;
    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.16);
  }
`
